import { Navigate, Route, useLocation } from 'react-router-dom'
import { NAVIGATION_LINKS } from '../../constants/routeConstants'

const PublicRoute = ({ children }) => {
    const location = useLocation()

    function hasJWT() {
        let flag = false

        //check user has JWT token
        sessionStorage.getItem('user') ? (flag = true) : (flag = false)

        return flag
    }
    if (hasJWT()) {
        return (
            <Navigate
                to={NAVIGATION_LINKS.DASHBOARD}
                replace
                state={{ from: location }}
            />
        )
    }

    return children
}
export default PublicRoute
